import styled, { css } from 'styled-components';

import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $bgType?: 'white' | 'black' | string;
}

export const Actionbar = styled.div<IProps>`
  font-family: 'Pretendard Variable', Pretendard, -apple-system,
    BlinkMacSystemFont, 'Apple SD Gothic Neo', Roboto, 'Noto Sans KR',
    'Segoe UI', 'Malgun Gothic', 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', sans-serif;

  position: relative;
  z-index: 100;

  .inner-actionbar {
    position: fixed;
    left: 0;
    right: 0;
    /* bottom: 0; */
    bottom: constant(safe-area-inset-bottom);
    bottom: env(safe-area-inset-bottom);
    width: 100%;
    z-index: 1;
    height: 50px;

    .actionbar-main {
      &::after {
        content: '';
        display: block;
        width: 100%;
        height: 100%;
        position: absolute;
        background: #f9f9f9;
        bottom: calc(-100% + 0.5px);
      }

      nav {
        ul {
          ${mixin.flex({})};
          background: #f9f9f9;
          padding: 3px 0;

          li {
            flex: 1;
            ${mixin.flex({})};

            .btn {
              ${mixin.flex({ direction: 'column', justify: 'flex-start' })};
              width: 48px;
              height: 44px;

              .icon {
                ${mixin.flex({})};
                width: 48px;
                height: 44px;
              }
            }
          }
        }
      }

      .float-btn {
        ${mixin.flex({ direction: 'column', align: 'flex-end' })};
        position: absolute;
        bottom: 60px;
        right: 16px;
        row-gap: 6px;

        .top-btn {
          opacity: 0;
          visibility: hidden;
          transition: opacity 0.3s, visibility 0.3s, bottom 0.3s;

          &.top-btn.active {
            opacity: 1;
            visibility: visible;
          }
        }
      }
    }
  }

  &.is-old-app-iphonex {
    .inner-actionbar {
      bottom: 34px;
    }
  }

  ${props => {
    if (props.$bgType === 'black') {
      return css`
        .inner-actionbar {
          .actionbar-main {
            &::after {
              background: rgba(0, 0, 0, 0.95);
            }

            nav {
              ul {
                background: #000;
              }
            }
          }
        }
      `;
    }
    return null;
  }}

  @media ${({ theme }) => theme.media.smMax} {
    .inner-actionbar {
      height: ${mixin.pxToVw('50')};

      .actionbar-main {
        nav {
          ul {
            padding: ${mixin.pxToVw('3 0')};

            li {
              .btn {
                width: ${mixin.pxToVw('48')};
                height: ${mixin.pxToVw('44')};

                .icon {
                  width: ${mixin.pxToVw('48')};
                  height: ${mixin.pxToVw('44')};

                  svg {
                    width: ${mixin.pxToVw('48')};
                    height: ${mixin.pxToVw('44')};
                  }
                }
              }
            }
          }
        }

        .float-btn {
          bottom: ${mixin.pxToVw('60')};
          right: ${mixin.pxToVw('16')};

          .btn {
            /* margin-top: ${mixin.pxToVw('6')}; */
          }
        }
      }
    }
  }
`;
